import React from 'react';
import { Icon, IconName } from '@jbhi-fi/lanyard-ui/components/Icon';
import { styles } from './ThumbnailIcon.css';
import { useTrackingContext } from '../Tracking';

export type ThumbnailIconProps = {
  iconName: IconName;
  title: string;
  href: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

export const ThumbnailIcon = ({ iconName, title, onClick, href }: ThumbnailIconProps) => {
  const { tracker } = useTrackingContext();

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = event => {
    tracker.trackClick({ label: title, extraData: { moduleName: 'Thumbnail icon' } });
    onClick?.(event);
  };

  return (
    <a className={styles.thumbnailIconContainer} href={href} onClick={handleClick}>
      <Icon name={iconName} className={styles.icon} placeholder={null} />
      <p className={styles.title}>{title}</p>
    </a>
  );
};
